<template>
  <div class="pcTDetail">
    <div class="list w100">
      <div class="lInfo">
        <div class="lName fb fOH">{{ teamInfo.nickname }}</div>
        <div class="lDesc fOR">{{ teamInfo.zw_name }}</div>
        <img class="lInfoImage" @click="goBack" src="../../../assets/image/team-bak.png" alt="">
      </div>
      <div class="lDesc fOb" @touchmove.prevent="onTouchMove" style="padding-top: 1rem" v-html="teamInfo.desc">
      </div>
    </div>
  </div>
</template>
<script>
import TeamMobileView from "@/components/Mobile/teamDetail.vue";

export default {
  components: {TeamMobileView},
  computed: {
    teamInfo(){
      return this.$store.getters.teamInfo
    }
  },
  methods:{
    goBack(){
      this.$emit('goDetail',false)
    },
    onTouchMove(event) {
      // 这里的 event 是触摸事件对象
      // 使用 .prevent 修饰符或者调用 event.preventDefault() 来阻止默认滚动行为
      event.preventDefault();
    },
  }
}
</script>
<style scoped lang="scss">
.pcTDetail{
  .list{
    box-sizing: border-box;
    overflow: hidden;
    height: 65vh;
    background: linear-gradient(-20deg, #185FCB 0%, #74B5D4 100%);
    border-radius: 20px;
    opacity: 0.95;
    padding: 1.3rem 1.3rem;
    //margin: 0 1.3rem;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    .lDesc{
      -webkit-overflow-scrolling: touch;
      flex: 1;
      overflow: hidden;
      overflow-y: scroll;
      font-size: .9rem;
      //padding-top: .3rem;
      line-height: 1.5rem;
    }
    .lInfo{
      padding-bottom: 1rem;
      border-bottom: .05rem solid rgba(255,255,255,.8);
      position: relative;
      .lInfoImage{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 10;
        width: 1rem;
      }
      .lName{
        font-size: 1.3rem;
      }
      .lDesc{
        font-size: .9rem;
        margin-top: .3rem;
      }
    }
  }
}
</style>
